import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Calculator } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login, formatApiError } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@contable.pe");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      navigate("/");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Error al iniciar sesión");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex relative bg-slate-900 text-white p-12 flex-col justify-between overflow-hidden">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: "url(https://images.unsplash.com/photo-1707077865701-2854996afc4f?crop=entropy&cs=srgb&fm=jpg&q=85)",
            backgroundSize: "cover", backgroundPosition: "center",
          }}
        />
        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded bg-blue-600 flex items-center justify-center">
              <Calculator className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="text-lg font-bold tracking-tight">CONTAPE</div>
              <div className="text-xs text-slate-400">Sistema Contable Perú</div>
            </div>
          </div>
        </div>
        <div className="relative z-10 space-y-4">
          <h1 className="text-3xl font-bold leading-tight">Contabilidad simple,<br/>cumpliendo SUNAT.</h1>
          <p className="text-sm text-slate-300 leading-relaxed max-w-md">
            Facturación electrónica, libros contables, planillas y reportes financieros — todo de acuerdo a la legislación peruana, en una sola plataforma.
          </p>
          <ul className="text-[12px] text-slate-300 space-y-1.5 pt-3 border-t border-slate-800">
            <li>• Facturas, Boletas, NC/ND con cálculo automático de IGV 18%</li>
            <li>• Plan Contable PCGE preinstalado</li>
            <li>• Multi-empresa (multi-RUC)</li>
            <li>• Libros y reportes para SUNAT</li>
          </ul>
        </div>
        <div className="relative z-10 text-[11px] text-slate-500">© {new Date().getFullYear()} CONTAPE</div>
      </div>

      <div className="flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-sm">
          <h2 className="text-2xl font-bold tracking-tight text-slate-900">Inicia sesión</h2>
          <p className="text-sm text-slate-500 mt-1 mb-6">Ingresa con tu cuenta para administrar tu contabilidad.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-[12px]">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-9" />
            </div>
            <div>
              <Label htmlFor="password" className="text-[12px]">Contraseña</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-9" />
            </div>
            <Button data-testid="login-submit" disabled={loading} className="w-full h-9 bg-slate-900 hover:bg-slate-800 text-white" type="submit">
              {loading ? "Ingresando..." : "Ingresar"}
            </Button>
          </form>
          <p className="text-[12px] text-slate-500 mt-4">
            ¿No tienes cuenta? <Link to="/register" data-testid="link-register" className="text-blue-600 hover:underline font-medium">Regístrate</Link>
          </p>
          <div className="mt-8 p-3 bg-slate-50 border border-slate-200 rounded text-[11px] text-slate-600">
            <div className="font-bold uppercase tracking-wider text-slate-700 mb-1">Cuenta demo</div>
            admin@contable.pe / admin123
          </div>
        </div>
      </div>
    </div>
  );
}
